import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColorGrade } from "../../models/Cosmetic";
import { User } from "../../models/User";
import {
  faStar,
  faUserCircle,
  faEdit,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Input } from "reactstrap";

type Props = {
  user: User | null;
  guid: string;
  grade: ColorGrade;
  update: Function;
  color: string;
};

const CosmeticProfileGrade = ({ user, guid, grade, update, color }: Props) => {
  const navigate = useNavigate();
  const [enableUpdateComment, setEnableUpdateComment] =
    useState<boolean>(false);
  const [gradeComment, setGradeComment] = useState<string>(grade.comment);

  const usernameClickHandler = (username: string) => {
    navigate(`/profile/${username}`);
  };
  const height = (grade.comment.length / 30 + 1) * 35;
  const isUserAuthor = grade.username === user?.userName;

  return (
    <React.Fragment>
      <tr>
        <td
          style={{ cursor: "pointer" }}
          onClick={() => usernameClickHandler(grade.username)}
        >
          <p
            style={
              isUserAuthor
                ? { color: "orange", fontWeight: "bold" }
                : { color: "inherit" }
            }
          >
            {grade.username}
            <FontAwesomeIcon
              color="lightgrey"
              style={{ fontSize: 15, marginLeft: 5 }}
              icon={faUserCircle}
            />
          </p>
        </td>
        <td>{new Date(grade.createDate).toLocaleDateString()}</td>
        <td>
          <FontAwesomeIcon color="lightgrey" icon={faStar} />{" "}
          <b>{grade.grade}</b>
        </td>
      </tr>
      <tr>
        <td colSpan={3} style={{ textAlign: "justify" }}>
          {enableUpdateComment ? (
            <div>
              <Input
                onChange={(e) => setGradeComment(e.target.value)}
                type="textarea"
                value={gradeComment}
                style={{ width: "90%", height: height }}
              />
              <FontAwesomeIcon
                onClick={() => {
                  update(guid, color, gradeComment);
                  setEnableUpdateComment(!enableUpdateComment);
                }}
                color="lightgrey"
                style={{ fontSize: 15, marginLeft: 5 }}
                icon={faSave}
              />
            </div>
          ) : (
            <div>
              {grade.comment}
              {isUserAuthor && (
                <FontAwesomeIcon
                  onClick={() => setEnableUpdateComment(!enableUpdateComment)}
                  color="lightgrey"
                  style={{ fontSize: 15, marginLeft: 5 }}
                  icon={faEdit}
                />
              )}
            </div>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CosmeticProfileGrade;
